import {
  FoodSelection,
  LogisticSelection,
} from 'services/api/entities/events/types/internal/selections'
import { TimeLabel } from 'services/utils/date'
import {
  yupArray,
  yupIgnore,
  yupNumber,
  yupObject,
  YupSchema,
  yupString,
} from 'services/yup'
import { productSelectionBaseVS } from './common/base'
import { optionedProductSelectionVS } from './common/optionedProduct'

const logisticSelectionVS: YupSchema<LogisticSelection> =
  productSelectionBaseVS.shape({
    price: yupIgnore(),
    pricing: yupArray(),
    quantity: yupIgnore(),
  })

const intoleranceSchema = (label: string) =>
  yupNumber()
    .transform((value: number) => (isNaN(value) ? undefined : value))
    .integer()
    .min(0)
    .optional()
    .label(label)

const intolerancesSelectionVS: YupSchema<FoodSelection['intolerances']> =
  yupObject().shape({
    gluten: intoleranceSchema('The number of gluten intolerant guests'),
    lactose: intoleranceSchema('The number of lactose intolerant guests'),
    vegan: intoleranceSchema('The number of vegan guests'),
    vegetarian: intoleranceSchema('The number of vegetarian guests'),
    other: yupString().optional(),
  })

export const foodSelectionVS: YupSchema<FoodSelection> =
  optionedProductSelectionVS.shape({
    deliveryTime: yupString<TimeLabel>().required(),
    intolerances: intolerancesSelectionVS,
    logisticSelection: logisticSelectionVS.required(),
  })
